import React from "react";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
  Button,
  Popover,
  Tabs,
  Tab,
} from "@mui/material";
import ChevronRightOutlined from "@mui/icons-material/ChevronRightOutlined";
import MenuOutlined from "@mui/icons-material/MenuOutlined";
import KeyboardArrowDownOutlined from "@mui/icons-material/KeyboardArrowDownOutlined";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { userHasRole } from "slices/auth";
import { Link as RouterLink } from "react-router-dom";
import TabPanel from "./TabPanel";

import GetMenuItems from "./MenuItems";
import { getRuntimeValue } from "config/runtime";

const MegaMenu = ({ isNavMenuOpen, setIsNavMenuOpen, isNonMobile }) => {
  const { pathname } = useLocation();
  const [activeArea, setActiveArea] = useState({});
  const [activeAreaName, setActiveAreaName] = useState("");
  const [activeItemName, setActiveItemName] = useState("");
  const navigate = useNavigate();
  const theme = useTheme();

  const swagger_path = getRuntimeValue("REACT_APP_SWAGGER_URL", "");


  const [anchorElMega, setAnchorElMega] = useState(null);
  const isOpenMega = Boolean(anchorElMega);
  const handleClickMenu = (event) => setAnchorElMega(event.currentTarget);
  const handleCloseMenu = () => setAnchorElMega(null);

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const user = useSelector((state) => state.auth.user?.user);

  const isAdmin = useSelector((state) => userHasRole(state, "SuperAdmin"));
  const isCustAdmin = useSelector((state) =>
    userHasRole(state, "CustomerAdmin")
  );

  const navAreas = GetMenuItems(user, swagger_path);

  const findParentAndSelectedItem = (navAreas, area) => {
    let parentItem = null;
    let selectedItem = null;

    for (const parent of navAreas) {
      if (parent.mainItems) {
        for (const item of parent.mainItems) {
          const parts = item.link?.split("/");
          let link = "";

          if (parts === undefined) {
            link = item.link;
          } else {
            link = parts[0];
          }

          if (link === area) {
            selectedItem = item;
            parentItem = parent;
            break; // Found the item, no need to continue searching
          }
        }
      }

      if (parent.currentStatusItems) {
        for (const item of parent.currentStatusItems) {
          const parts = item.link?.split("/");
          let link = "";

          if (parts === undefined) {
            link = item.link;
          } else {
            link = parts[0];
          }

          if (link === area) {
            selectedItem = item;
            parentItem = parent;
            break; // Found the item, no need to continue searching
          }
        }
      }

      if (parent.setupItems) {
        for (const item of parent.setupItems) {
          const parts = item.link?.split("/");
          let link = "";

          if (parts === undefined) {
            link = item.link;
          } else {
            link = parts[0];
          }

          if (link === area) {
            selectedItem = item;
            parentItem = parent;
            break; // Found the item, no need to continue searching
          }
        }
      }

      if (parent.configgurationItems) {
        for (const item of parent.configgurationItems) {
          const parts = item.link?.split("/");
          let link = "";

          if (parts === undefined) {
            link = item.link;
          } else {
            link = parts[0];
          }

          if (link === area) {
            selectedItem = item;
            parentItem = parent;
            break; // Found the item, no need to continue searching
          }
        }
      }

      if (parent.customItems) {
        for (const item of parent.customItems) {
          const parts = item.link?.split("/");
          let link = "";

          if (parts === undefined) {
            link = item.link;
          } else {
            link = parts[0];
          }

          if (link === area) {
            selectedItem = item;
            parentItem = parent;
            break; // Found the item, no need to continue searching
          }
        }
      }

      if (parent.masterDataItems) {
        for (const item of parent.masterDataItems) {
          const parts = item.link?.split("/");
          let link = "";

          if (parts === undefined) {
            link = item.link;
          } else {
            link = parts[0];
          }

          if (link === area) {
            selectedItem = item;
            parentItem = parent;
            break; // Found the item, no need to continue searching
          }
        }
      }




      if (selectedItem) {
        break; // Found the item, no need to continue searching
      }
    }

    return { parentItem, selectedItem };
  };

  const RenderItems = (items, column) => {
    let start,
      end = 0;

    if (column === 1) {
      start = 0;
      end = navAreas.length + 1;
    }

    if (column === 2) {
      start = navAreas.length + 1;
      end = navAreas.length * 2 + 2;
    }

    if (column === 3) {
      start = navAreas.length * 2 + 2;
      end = navAreas.length * 3 + 3;
    }

    if (column === 4) {
      start = navAreas.length * 3 + 3;
      end = navAreas.length * 4 + 4;
    }

    return (
      <List sx={{ width: menuWidth, py: 1, px: 0.5 }}>
        {items
          ?.slice(start, end)
          .map(({ text, icon, link, external, header }) => {
            if (header) {
              return (
                <ListItem
                  key={"header_" + text}
                  disablePadding
                  sx={{ mt: 1, mb: 0.5, px: 1 }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 28,
                      color: theme.palette.primary.main,
                    }}
                  >
                    {icon}
                  </ListItemIcon>

                  <ListItemText
                    primary={text}
                    primaryTypographyProps={{
                      color: theme.palette.primary.main,
                      fontWeight: 700,
                      fontSize: "0.78rem",
                      letterSpacing: "0.08em",
                      textTransform: "uppercase",
                    }}
                  />
                </ListItem>
              );
            }

            const active = activeItemName === text;
            return (
              <ListItem key={"item_" + text} disablePadding sx={{ mb: 0.2 }}>
                <ListItemButton
                  component={external ? "a" : RouterLink}
                  href={external ? link : undefined}
                  target={external ? "_blank" : undefined}
                  to={external ? undefined : `/${link}`}
                  onClick={() => handleCloseMenu()}
                  sx={{
                    pl: 4,
                    pr: 1.5,
                    py: 0.6,
                    borderRadius: "8px",
                    backgroundColor: active
                      ? `${theme.palette.primary.main}14`
                      : "transparent",
                    transition: "background-color 120ms ease, padding 160ms ease",
                    "&:hover": {
                      backgroundColor: active
                        ? `${theme.palette.primary.main}1f`
                        : theme.palette.action.hover,
                      pl: 4.5,
                    },
                  }}
                >
                  <ListItemText
                    primary={text}
                    primaryTypographyProps={{
                      fontSize: "0.92rem",
                      fontWeight: active ? 600 : 400,
                      color: active
                        ? theme.palette.primary.main
                        : theme.palette.text.primary,
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
      </List>
    );
  };

  const menuWidth = 250;

  useEffect(() => {
    //get the first element from the path,
    //look up the menu item that has this link and then find its parent,
    //set that as the active area

    const areaToSearch = pathname.substring(1);
    const parts = areaToSearch.split("/");
    const area = parts[0];

    const { parentItem, selectedItem } = findParentAndSelectedItem(
      navAreas,
      area
    );


    setActiveAreaName(parentItem?.text);
    setActiveItemName(selectedItem?.text);
    setActiveArea(parentItem);
  }, [pathname]);

  const [tabValue, setTabValue] = React.useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <>
      <Button
        onClick={handleClickMenu}
        aria-haspopup="menu"
        aria-expanded={isOpenMega ? "true" : "false"}
        sx={{
          display: "flex",
          alignItems: "center",
          textTransform: "none",
          gap: 0.75,
          px: 1.25,
          py: 0.75,
          borderRadius: "10px",
          color: theme.palette.primary.main,
          border: `1px solid ${isOpenMega ? theme.palette.primary.main : "transparent"}`,
          backgroundColor: isOpenMega
            ? `${theme.palette.primary.main}14`
            : "transparent",
          transition: "all 160ms ease",
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
            borderColor: theme.palette.primary.main,
          },
        }}
      >
        <MenuOutlined sx={{ fontSize: 20 }} />

        <Box textAlign="left">
          <Typography
            fontWeight={600}
            fontSize="1.05rem"
            letterSpacing="0.005em"
            sx={{ color: theme.palette.primary.main, lineHeight: 1.2 }}
          >
            {activeItemName || "Menu"}
          </Typography>
        </Box>

        <KeyboardArrowDownOutlined
          sx={{
            fontSize: 18,
            color: theme.palette.primary[300] || theme.palette.primary.main,
            transition: "transform 200ms ease",
            transform: isOpenMega ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </Button>

      <Popover
        id="megaMenu"
        open={isOpenMega}
        anchorEl={anchorElMega}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              mt: 1,
              borderRadius: "14px",
              border: `1px solid ${theme.palette.divider}`,
              overflow: "hidden",
              boxShadow:
                theme.palette.mode === "dark"
                  ? "0 12px 40px rgba(0,0,0,0.5)"
                  : "0 1px 2px rgba(15,23,42,0.04), 0 16px 40px rgba(15,23,42,0.10)",
            },
          },
        }}
      >
        <Box display="flex" flexDirection="row" gap={0}>
          <List
            sx={{
              width: menuWidth,
              backgroundColor: theme.palette.background.light,
              borderRight: `1px solid ${theme.palette.divider}`,
              py: 1,
              px: 0.75,
            }}
          >
            {navAreas.map((item) => {
              const active = activeAreaName === item.text;
              return (
                <ListItem key={item.text} disablePadding sx={{ mb: 0.25 }}>
                  <ListItemButton
                    onClick={() => {
                      setActiveArea(item);
                      setActiveAreaName(item.text);
                    }}
                    sx={{
                      borderRadius: "10px",
                      pl: 1.5,
                      pr: 1,
                      py: 0.85,
                      position: "relative",
                      backgroundColor: active
                        ? `${theme.palette.primary.main}14`
                        : "transparent",
                      transition: "background-color 140ms ease",
                      "&:hover": {
                        backgroundColor: active
                          ? `${theme.palette.primary.main}1f`
                          : theme.palette.action.hover,
                      },
                      "&:before": active
                        ? {
                            content: '""',
                            position: "absolute",
                            left: 4,
                            top: 8,
                            bottom: 8,
                            width: 3,
                            borderRadius: 2,
                            backgroundColor: theme.palette.primary.main,
                          }
                        : {},
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 30,
                        color: active
                          ? theme.palette.primary.main
                          : theme.palette.text.secondary,
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>

                    <ListItemText
                      primary={item.text}
                      primaryTypographyProps={{
                        fontSize: "0.95rem",
                        fontWeight: active ? 600 : 500,
                        color: active
                          ? theme.palette.primary.main
                          : theme.palette.text.primary,
                      }}
                    />

                    <ChevronRightOutlined
                      sx={{
                        ml: "auto",
                        fontSize: 18,
                        color: active
                          ? theme.palette.primary.main
                          : theme.palette.text.disabled,
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>

          <Box sx={{ minWidth: menuWidth * 3, backgroundColor: theme.palette.background.paper }}>
            <Box sx={{ borderBottom: `1px solid ${theme.palette.divider}`, px: 1.5 }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="Menu Tabs"
                sx={{
                  minHeight: 42,
                  "& .MuiTab-root": {
                    minHeight: 42,
                    textTransform: "none",
                    fontSize: "0.95rem",
                    fontWeight: 600,
                    letterSpacing: "0.01em",
                    color: theme.palette.text.secondary,
                    "&.Mui-selected": { color: theme.palette.primary.main },
                  },
                  "& .MuiTabs-indicator": {
                    height: 2,
                    borderRadius: 2,
                    backgroundColor: theme.palette.primary.main,
                  },
                }}
              >
                <Tab
                  label={activeAreaName !== "Admin" ? "Main" : "Current Status"}
                  {...a11yProps(0)}
                />
                <Tab
                  label={
                    activeAreaName !== "Admin" ? "Setup" : "Configguration"
                  }
                  {...a11yProps(1)}
                />
                <Tab
                  label={activeAreaName !== "Admin" ? "Custom" : "Master Data"}
                  {...a11yProps(2)}
                />
              </Tabs>
            </Box>

            <TabPanel value={tabValue} index={0}>
              <Box display="flex" flexDirection="row" gap=".2rem">
                {activeAreaName !== "Admin"
                  ? RenderItems(activeArea?.mainItems, 1)
                  : RenderItems(activeArea?.currentStatusItems, 1)}

                <Divider orientation="vertical" flexItem variant="middle" />

                {activeAreaName !== "Admin"
                  ? RenderItems(activeArea?.mainItems, 2)
                  : RenderItems(activeArea?.currentStatusItems, 2)}

                <Divider orientation="vertical" flexItem variant="middle" />

                {activeAreaName !== "Admin"
                  ? RenderItems(activeArea?.mainItems, 3)
                  : RenderItems(activeArea?.currentStatusItems, 3)}
              </Box>
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
              <Box display="flex" flexDirection="row" gap=".2rem">
              {activeAreaName !== "Admin"
                  ? RenderItems(activeArea?.setupItems, 1)
                  : RenderItems(activeArea?.configItems, 1)}

                <Divider orientation="vertical" flexItem variant="middle" />

                {activeAreaName !== "Admin"
                  ? RenderItems(activeArea?.setupItems, 2)
                  : RenderItems(activeArea?.configItems, 2)}

                <Divider orientation="vertical" flexItem variant="middle" />

                {activeAreaName !== "Admin"
                  ? RenderItems(activeArea?.setupItems, 3)
                  : RenderItems(activeArea?.configItems, 3)}
              </Box>
            </TabPanel>

            <TabPanel value={tabValue} index={2}>
              <Box display="flex" flexDirection="row" gap=".2rem">
              {activeAreaName !== "Admin"
                  ? RenderItems(activeArea?.customItems, 1)
                  : RenderItems(activeArea?.masterDataItems, 1)}

                <Divider orientation="vertical" flexItem variant="middle" />

                {activeAreaName !== "Admin"
                  ? RenderItems(activeArea?.customItems, 2)
                  : RenderItems(activeArea?.masterDataItems, 2)}

                <Divider orientation="vertical" flexItem variant="middle" />

                {activeAreaName !== "Admin"
                  ? RenderItems(activeArea?.customItems, 3)
                  : RenderItems(activeArea?.masterDataItems, 3)}
              </Box>
            </TabPanel>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default MegaMenu;
